import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import './Footer.css';
import reportWebVitals from './reportWebVitals';
import { CurrencyProvider } from './components/CurrencyContext';
<link
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  rel="stylesheet"
/>


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CurrencyProvider>  
      <App />
    </CurrencyProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
